import { required } from "common/forms"
import * as Yup from "yup"

const schema = Yup.object({
  skuOrName: Yup.string().required(required.skuOrName),
}).defined()

export const initialFormState: Yup.InferType<typeof schema> = {
  skuOrName: "",
}

export default schema
